import { useLanguageContext } from "@@/settings/language-context";
import type { LanguageCode } from "@towni/common";

const useSelectedLanguageCode = (): LanguageCode => {
    const { language } = useLanguageContext();
    return language;
};

export { useSelectedLanguageCode };
